import { apiFetch } from '../../Util';

async function createSavedCart(description = '') {
  const result = await apiFetch.create(['saved_cart'], { description });
  return result.created;
}

export default createSavedCart;
